export var AdditionalInfoView;
(function (AdditionalInfoView) {
    AdditionalInfoView[AdditionalInfoView["Upload"] = 0] = "Upload";
    AdditionalInfoView[AdditionalInfoView["Review"] = 1] = "Review";
    AdditionalInfoView[AdditionalInfoView["CancelConfirmation"] = 2] = "CancelConfirmation";
    AdditionalInfoView[AdditionalInfoView["SubmitConfirmation"] = 3] = "SubmitConfirmation";
    AdditionalInfoView[AdditionalInfoView["DeleteConfirmation"] = 4] = "DeleteConfirmation";
})(AdditionalInfoView || (AdditionalInfoView = {}));
//# sourceMappingURL=typings.js.map